import React, { useState } from 'react';

import TagCreate from './TagCreate';
import TagEdit from './TagEdit';
import TagsList from './TagsList';

export default function Tags() {
  const [view, setView] = useState<'list' | 'create' | 'edit'>('list');
  const [selectedTagId, setSelectedTagId] = useState<string | null>(null);
  const [initialTab, setInitialTab] = useState<string | undefined>(undefined);

  const handleBack = () => {
    setView('list');
    setSelectedTagId(null);
    setInitialTab(undefined);
  };

  const handleCreate = () => {
    setView('create');
    setSelectedTagId(null);
    setInitialTab(undefined);
  };

  const handleEdit = (tagId: string) => {
    setView('edit');
    setSelectedTagId(tagId);
    setInitialTab(undefined);
  };

  const handleEditWithTab = (tagId: string, tab: string) => {
    setView('edit');
    setSelectedTagId(tagId);
    setInitialTab(tab);
  };

  return (
    <>
      {view === 'create' && <TagCreate onBack={handleBack} onEditTag={handleEditWithTab} />}
      {view === 'edit' && selectedTagId && (
        <TagEdit tagId={selectedTagId} onBack={handleBack} initialTab={initialTab} />
      )}
      {view === 'list' && <TagsList onCreate={handleCreate} onEdit={handleEdit} />}
    </>
  );
}
